import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';

export interface ReclassifySuccessScreenProps {
  onClose: () => void;
}

export const ReclassifySuccessScreen = ({ onClose }: ReclassifySuccessScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.forecasting.changes_saved',
          defaultMessage: 'Changes saved'
        })}
      />
    </WizardScreen>
  );
};
